<template>
  <div class="about">
    <section class="section">
      <h1>Iventerの使い方</h1>
      <h1>イベントについて</h1>
      <h1>商品について</h1>
    </section>
  </div>
</template>

<script>
export default {
  name: "abut",
  data: function() {
    return {};
  }
};
</script>
